"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _reactRedux = require("react-redux");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H6"));

var _colors = require("HubStyleTokens/colors");

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIBadge = _interopRequireDefault(require("UIComponents/badge/UIBadge"));

var _reactRouterDom = require("react-router-dom");

var _responsiveBreakpoints = _interopRequireDefault(require("../utils/responsiveBreakpoints"));

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _Wp006Selectors = require("pricing-pages-unified-ui/selectors/Wp006Selectors");

var _Wp006SimplifyTabsActions = require("pricing-pages-unified-ui/actions/Wp006SimplifyTabsActions");

var _classNames = _interopRequireDefault(require("pricing-pages-unified-ui/utils/classNames"));

var _ExperimentTreatmentSelectors = require("pricing-pages-unified-ui/selectors/ExperimentTreatmentSelectors");

var _ExperimentConstants = require("pricing-pages-unified-ui/constants/ExperimentConstants");

function _templateObject18() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  transform: scale(0.45) translateY(-50%);\n  position: absolute;\n  right: 0.06em;\n  margin: 0;\n  top: 50%;\n  color: ", ";\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 0.515em;\n  letter-spacing: 0.5px;\n  margin-bottom: 0.515em;\n  opacity: 0.7;\n  font-weight: 600;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: block;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  transform: scale(0.6);\n  right: 34px;\n  top: 13px;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-block;\n  font-size: 1.57em;\n  line-height: 1.4;\n  &[selected='true'] {\n    text-decoration: underline;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  display: flex;\n  margin: 0 auto 1.57em 0;\n  align-items: center;\n  cursor: pointer;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-direction: column;\n  padding: 40px 0;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  visibility: hidden;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  right: 20px;\n  top: 22px;\n  display: none;\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: #167186;\n  background-image: linear-gradient(to top right, #167186, #167d7a);\n  color: ", ";\n\n  &.pricing-mobile-menu-body {\n    padding: 3.4em 1.45em;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: 800;\n  display: block;\n  position: relative;\n  overflow: hidden;\n  font-size: 0.85em;\n  opacity: 0.7;\n  margin-top: 1.37em;\n  margin-bottom: 0.15em;\n  &:first-child {\n    margin-top: 0;\n  }\n  &::after {\n    content: '';\n    display: inline-block;\n    background-color: ", ";\n    height: 1px;\n    position: absolute;\n    top: 50%;\n    transform: translate(10px, -50%);\n    width: 100%;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    text-align: left;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: block;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: none;\n  text-align: center;\n  width: 100%;\n  cursor: pointer;\n  background-color: #167186;\n  background-image: linear-gradient(to top right, #167186, #167d7a);\n  color: ", ";\n  font-size: 1.6em;\n  font-weight: 100;\n  padding: 0.6em 2.4em 0.86em 0.7em;\n\n  ", "\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  top: -11px;\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin: 0;\n  font-weight: bold;\n  font-size: 8pt;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      border-bottom: none;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: ", ";\n  display: flex;\n  justify-content: space-around;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding-left: ", "px;\n  padding-right: ", "px;\n\n  &.mon307-bottom-border {\n    border-bottom: 1px solid ", ";\n\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StickyContainer = _styledComponents.default.div.withConfig({
  displayName: "Tabs__StickyContainer",
  componentId: "sc-69wqxo-0"
})(_templateObject(), _colors.OLAF, function (props) {
  return props.withPadding ? 200 : 0;
}, function (props) {
  return props.withPadding ? 200 : 0;
}, _colors.BATTLESHIP, _responsiveBreakpoints.default.tablet(_templateObject2()));

var TabDiscountBadge = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "Tabs__TabDiscountBadge",
  componentId: "sc-69wqxo-1"
})(_templateObject3());

var DiscountBadgeContainer = _styledComponents.default.div.withConfig({
  displayName: "Tabs__DiscountBadgeContainer",
  componentId: "sc-69wqxo-2"
})(_templateObject4());

var MobileMenuTriggers = (0, _styledComponents.default)(StickyContainer).withConfig({
  displayName: "Tabs__MobileMenuTriggers",
  componentId: "sc-69wqxo-3"
})(_templateObject5(), _colors.OLAF, _responsiveBreakpoints.default.tablet(_templateObject6()), _responsiveBreakpoints.default.phone(_templateObject7()));
var MobileMenuCategory = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "Tabs__MobileMenuCategory",
  componentId: "sc-69wqxo-4"
})(_templateObject8(), _colors.OLAF);
var MobileMenuBody = (0, _styledComponents.default)(_UIDialogBody.default).withConfig({
  displayName: "Tabs__MobileMenuBody",
  componentId: "sc-69wqxo-5"
})(_templateObject9(), _colors.OLAF);
var Wp006SimpleButton = (0, _styledComponents.default)(_UIButton.default).withConfig({
  displayName: "Tabs__Wp006SimpleButton",
  componentId: "sc-69wqxo-6"
})(_templateObject10(), _responsiveBreakpoints.default.tablet(_templateObject11()));

var MobileMenuBodyInner = _styledComponents.default.div.withConfig({
  displayName: "Tabs__MobileMenuBodyInner",
  componentId: "sc-69wqxo-7"
})(_templateObject12());

var MobileMenuLinkWrapper = _styledComponents.default.div.withConfig({
  displayName: "Tabs__MobileMenuLinkWrapper",
  componentId: "sc-69wqxo-8"
})(_templateObject13());

var MobileMenuLink = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "Tabs__MobileMenuLink",
  componentId: "sc-69wqxo-9"
})(_templateObject14());
var MobileMenuCloseButton = (0, _styledComponents.default)(_UIDialogCloseButton.default).withConfig({
  displayName: "Tabs__MobileMenuCloseButton",
  componentId: "sc-69wqxo-10"
})(_templateObject15());
var MobileMenuTriggerLink = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "Tabs__MobileMenuTriggerLink",
  componentId: "sc-69wqxo-11"
})(_templateObject16());
var MobileMenuTriggerCategory = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "Tabs__MobileMenuTriggerCategory",
  componentId: "sc-69wqxo-12"
})(_templateObject17());
var MobileMenuTriggerIcon = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "Tabs__MobileMenuTriggerIcon",
  componentId: "sc-69wqxo-13"
})(_templateObject18(), _colors.OLAF);

var MenuBadge = function MenuBadge(_ref) {
  var className = _ref.className,
      _ref$use = _ref.use,
      use = _ref$use === void 0 ? 'new' : _ref$use,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className", "use", "children"]);
  return _react.default.createElement(_UIBadge.default, (0, _extends2.default)({
    use: use,
    className: (0, _classNames.default)('m-left-2', className)
  }, rest), children);
};

function Tabs(_ref2) {
  var selectedPrimaryTab = _ref2.selectedPrimaryTab,
      selectedSecondaryTab = _ref2.selectedSecondaryTab,
      history = _ref2.history,
      defaultHubRoute = _ref2.defaultHubRoute,
      isHSFXEligible = _ref2.isHSFXEligible,
      isLatamEsEligible = _ref2.isLatamEsEligible,
      hasSimplifyTabs = _ref2.hasSimplifyTabs,
      onSimplifyTabs = _ref2.onSimplifyTabs,
      hasShowButton = _ref2.hasShowButton;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isModalVisible = _useState2[0],
      setModalVisibility = _useState2[1];

  var toggleModal = function toggleModal(isVisible) {
    return setModalVisibility(isVisible);
  };

  var discountBadgeKey = isLatamEsEligible ? 'latamEsPercentDiscountBadge' : 'percentDiscountBadge';

  var navigateTo = function navigateTo(path) {
    //For MON224 - save the show-tts-isc-chat param if present
    var pathWithSavedParams = window.location.search.includes('show-tts-chat=true') ? path + "?show-tts-chat=true" : path;
    history.push(pathWithSavedParams);
    window.scrollTo(0, 0);
  }; //WP006


  var Wp006DisplaySimplifyButton = ['marketing', 'crm', 'sales'].includes(selectedSecondaryTab) && hasShowButton;
  var Wp006SimpleButtonText = hasSimplifyTabs ? 'pricingPage.wp006Simplify.showAll' : 'pricingPage.wp006Simplify.showFewer';
  var isMon307StickyHeader = (0, _reactRedux.useSelector)(_ExperimentTreatmentSelectors.mon307TtsStyleSelector) === _ExperimentConstants.MON307_TTS_STYLE_OPTIONS.STICKY_HEADER && ['marketing', 'sales', 'service', 'cms'].includes(selectedSecondaryTab);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(MobileMenuTriggers, {
    onClick: (0, _partial.default)(toggleModal, true),
    className: "mobile-menu-tab-triggers"
  }, selectedPrimaryTab === 'crm' && _react.default.createElement("div", null, _react.default.createElement(MobileMenuTriggerCategory, {
    message: "pricingPage.productCategories.freeToolsAndCrm"
  }), _react.default.createElement(MobileMenuTriggerLink, {
    message: "pricingPage.pages.crm.tabTitle",
    onClick: (0, _partial.default)(toggleModal, true)
  })), selectedSecondaryTab === 'crm' && _react.default.createElement("div", null, _react.default.createElement(MobileMenuTriggerCategory, {
    message: "pricingPage.pages.products.tabTitle"
  }), _react.default.createElement(MobileMenuTriggerLink, {
    message: "pricingPage.pages.crm.tabTitle",
    onClick: (0, _partial.default)(toggleModal, true)
  })), selectedSecondaryTab === 'marketing' && _react.default.createElement("div", null, _react.default.createElement(MobileMenuTriggerCategory, {
    message: "pricingPage.pages.products.tabTitle"
  }), _react.default.createElement(MobileMenuTriggerLink, {
    message: "pricingPage.pages.products.tabs.marketing.tabTitle",
    onClick: (0, _partial.default)(toggleModal, true)
  })), selectedSecondaryTab === 'sales' && _react.default.createElement("div", null, _react.default.createElement(MobileMenuTriggerCategory, {
    message: "pricingPage.pages.products.tabTitle"
  }), _react.default.createElement(MobileMenuTriggerLink, {
    message: "pricingPage.pages.products.tabs.sales.tabTitle",
    onClick: (0, _partial.default)(toggleModal, true)
  })), selectedSecondaryTab === 'service' && _react.default.createElement("div", null, _react.default.createElement(MobileMenuTriggerCategory, {
    message: "pricingPage.pages.products.tabTitle"
  }), _react.default.createElement(MobileMenuTriggerLink, {
    message: "pricingPage.pages.products.tabs.service.tabTitle",
    onClick: (0, _partial.default)(toggleModal, true)
  })), selectedSecondaryTab === 'cms' && _react.default.createElement("div", null, _react.default.createElement(MobileMenuTriggerCategory, {
    message: "pricingPage.pages.products.tabTitle"
  }), _react.default.createElement(MobileMenuTriggerLink, {
    message: "pricingPage.pages.products.tabs.cmsHub.tabTitle",
    onClick: (0, _partial.default)(toggleModal, true)
  })), selectedPrimaryTab === 'growth-suite' && _react.default.createElement("div", null, _react.default.createElement(MobileMenuTriggerCategory, {
    message: "pricingPage.productCategories.premiumProducts"
  }), _react.default.createElement(MobileMenuTriggerLink, {
    message: "pricingPage.pages.products.tabs.growthSuite.tabTitle",
    onClick: (0, _partial.default)(toggleModal, true)
  })), selectedPrimaryTab === 'bundle' && _react.default.createElement("div", null, _react.default.createElement(MobileMenuTriggerCategory, {
    message: "pricingPage.productCategories.bundles"
  }), _react.default.createElement(MobileMenuTriggerLink, {
    message: "pricingPage.pages.bundle.tabTitle",
    onClick: (0, _partial.default)(toggleModal, true)
  })), _react.default.createElement(MobileMenuTriggerIcon, {
    name: "down",
    size: "sm",
    color: _colors.OLAF
  })), isModalVisible && _react.default.createElement(_UIModal.default, null, _react.default.createElement(MobileMenuCloseButton, {
    onClick: (0, _partial.default)(toggleModal, false),
    size: "xl"
  }), _react.default.createElement(MobileMenuBody, {
    className: "pricing-mobile-menu-body"
  }, _react.default.createElement(MobileMenuBodyInner, null, _react.default.createElement(MobileMenuCategory, {
    message: "pricingPage.pages.products.tabTitle"
  }), _react.default.createElement(MobileMenuLinkWrapper, {
    onClick: (0, _partial.default)(navigateTo, '/crm')
  }, _react.default.createElement(MobileMenuLink, {
    selected: selectedSecondaryTab === 'crm',
    message: "pricingPage.pages.crm.tabTitle"
  })), _react.default.createElement(MobileMenuLinkWrapper, {
    onClick: (0, _partial.default)(navigateTo, '/marketing')
  }, _react.default.createElement(MobileMenuLink, {
    selected: selectedSecondaryTab === 'marketing',
    message: "pricingPage.pages.products.tabs.marketing.tabTitle"
  })), _react.default.createElement(MobileMenuLinkWrapper, {
    onClick: (0, _partial.default)(navigateTo, '/sales')
  }, _react.default.createElement(MobileMenuLink, {
    selected: selectedSecondaryTab === 'sales',
    message: "pricingPage.pages.products.tabs.sales.tabTitle"
  })), _react.default.createElement(MobileMenuLinkWrapper, {
    onClick: (0, _partial.default)(navigateTo, '/service')
  }, _react.default.createElement(MobileMenuLink, {
    selected: selectedSecondaryTab === 'service',
    message: "pricingPage.pages.products.tabs.service.tabTitle"
  })), _react.default.createElement(MobileMenuLinkWrapper, {
    onClick: (0, _partial.default)(navigateTo, '/cms')
  }, _react.default.createElement(MobileMenuLink, {
    selected: selectedSecondaryTab === 'cms',
    message: "pricingPage.pages.products.tabs.cmsHub.tabTitle"
  }), _react.default.createElement(MenuBadge, null, _react.default.createElement(_FormattedMessage.default, {
    message: 'pricingPage.new'
  }))), _react.default.createElement(MobileMenuCategory, {
    message: "pricingPage.productCategories.bundles"
  }), _react.default.createElement(MobileMenuLinkWrapper, {
    onClick: (0, _partial.default)(navigateTo, '/growth-suite')
  }, _react.default.createElement(MobileMenuLink, {
    selected: selectedSecondaryTab === 'growth-suite',
    message: "pricingPage.pages.products.tabs.growthSuite.tabTitle"
  }), !isHSFXEligible && _react.default.createElement(MenuBadge, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.growthSuite." + discountBadgeKey
  }))), _react.default.createElement(MobileMenuLinkWrapper, {
    onClick: (0, _partial.default)(navigateTo, '/bundle')
  }, _react.default.createElement(MobileMenuLink, {
    selected: selectedSecondaryTab === 'create-a-bundle',
    message: "pricingPage.pages.bundle.tabTitle"
  }))))), !hasSimplifyTabs && _react.default.createElement(_UITabs.default, {
    selected: selectedPrimaryTab,
    use: "enclosed",
    wrapperClassName: "pricing-page-tabs md-hidden"
  }, _react.default.createElement(_UITab.default, {
    tabId: "products",
    className: "pricing-page-tab",
    onClick: function onClick() {
      navigateTo(defaultHubRoute);
    },
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.products.tabTitle"
    })
  }), _react.default.createElement(_UITab.default, {
    tabId: "bundle",
    className: "pricing-page-tab",
    onClick: (0, _partial.default)(navigateTo, '/growth-suite'),
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.productCategories.bundles"
    })
  })), // render secondary tabs for 'products' tab
  selectedPrimaryTab === 'products' && _react.default.createElement(StickyContainer, {
    withPadding: hasShowButton,
    className: isMon307StickyHeader ? 'mon307-bottom-border' : '',
    style: isMon307StickyHeader ? {
      boxShadow: 'none'
    } : {}
  }, _react.default.createElement(_UITabs.default, {
    selected: selectedSecondaryTab,
    wrapperClassName: "products-page-tabs md-hidden",
    bordered: !isMon307StickyHeader
  }, _react.default.createElement(_UITab.default, {
    tabId: "crm",
    className: "products-page-tab",
    onClick: (0, _partial.default)(navigateTo, '/crm'),
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.tabTitle"
    })
  }), _react.default.createElement(_UITab.default, {
    tabId: "marketing",
    className: "products-page-tab",
    onClick: (0, _partial.default)(navigateTo, '/marketing'),
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.products.tabs.marketing.tabTitle"
    })
  }), _react.default.createElement(_UITab.default, {
    tabId: "sales",
    className: "products-page-tab",
    onClick: (0, _partial.default)(navigateTo, '/sales'),
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.products.tabs.sales.tabTitle"
    })
  }), !hasSimplifyTabs && _react.default.createElement(_UITab.default, {
    tabId: "service",
    className: "products-page-tab",
    onClick: (0, _partial.default)(navigateTo, '/service'),
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.products.tabs.service.tabTitle"
    })
  }), !hasSimplifyTabs && _react.default.createElement(_UITab.default, {
    tabId: "cms",
    className: "products-page-tab",
    onClick: (0, _partial.default)(navigateTo, '/cms'),
    title: _react.default.createElement("div", {
      className: "justify-center align-center"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.products.tabs.cmsHub.tabTitle"
    }), _react.default.createElement(MenuBadge, {
      style: {
        marginBottom: 2
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: 'pricingPage.new'
    })))
  })), Wp006DisplaySimplifyButton && _react.default.createElement(Wp006SimpleButton, {
    size: "extra-small",
    use: "tertiary-light",
    onClick: function onClick() {
      return onSimplifyTabs(!hasSimplifyTabs);
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: Wp006SimpleButtonText
  }))), // render secondary tabs for 'bundles' tab
  selectedPrimaryTab === 'bundle' && _react.default.createElement(StickyContainer, null, _react.default.createElement(_UITabs.default, {
    selected: selectedSecondaryTab,
    wrapperClassName: "products-page-tabs md-hidden"
  }, _react.default.createElement(_UITab.default, {
    tabId: "growth-suite",
    className: "products-page-tab",
    onClick: (0, _partial.default)(navigateTo, '/growth-suite'),
    title: _react.default.createElement("div", {
      style: {
        position: 'relative'
      }
    }, isHSFXEligible ? null : _react.default.createElement(DiscountBadgeContainer, null, _react.default.createElement(TabDiscountBadge, null, _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.growthSuite." + discountBadgeKey
    }))), _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.products.tabs.growthSuite.tabTitle"
    }))
  }), _react.default.createElement(_UITab.default, {
    tabId: "create-a-bundle",
    className: "products-page-tab",
    onClick: (0, _partial.default)(navigateTo, '/bundle'),
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.bundle.tabTitle"
    })
  }))));
}

function mapStateToProps(state) {
  return {
    defaultHubRoute: state.config.defaultHubRoute,
    isHSFXEligible: (0, _PromotionSelectors.isHSFXEligibleSelector)(state),
    isLatamEsEligible: (0, _PromotionSelectors.isLatamEsEligibleSelector)(state),
    //WP006
    hasSimplifyTabs: (0, _Wp006Selectors.hasSimplifyTabsSelector)(state),
    hasShowButton: (0, _Wp006Selectors.hasShowButtonSelector)(state)
  };
} //WP006


var mapDispatchToProps = {
  onSimplifyTabs: _Wp006SimplifyTabsActions.updateSimplifyTabs
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Tabs));

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/Tabs.js
// module id = 599
// module chunks = 5 6